import React from 'react';
import { InstagramIcon, FacebookIcon, MusicIcon, PhoneIcon } from 'lucide-react';
import { CONTACT, LOGO } from '../data/copy';
import { useLanguage } from '../contexts/LanguageContext';
const socials = [{
  label: 'Instagram',
  Icon: InstagramIcon
}, {
  label: 'Facebook',
  Icon: FacebookIcon
}, {
  label: 'TikTok',
  Icon: MusicIcon
}];
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="w-full bg-forest-deep" data-id="element-86" data-mp="3uesbtlhsjbjo">
      <div className="mx-auto max-w-7xl px-5 py-14 lg:px-8 lg:py-16" data-id="element-87" data-mp="3ucxmluzhkx9s">
        <div className="grid gap-10 md:grid-cols-[minmax(0,1.4fr)_minmax(0,1fr)_minmax(0,1fr)]" data-id="element-88" data-mp="37fpks21w7ww">
          <div data-id="element-89" data-mp="3ldkdx4j6scq4">
            <div className="max-w-xs" data-id="element-90" data-mp="3le2jwsvni5b8">
              <span className="flex items-center justify-center" data-id="element-91" data-mp="3qd6rjf2xfuzg">
                <img src="https://i.imgur.com/Wx3mHZ2.png" alt={LOGO.alt} className="h-20 w-auto object-contain" data-id="element-92" data-mp="3qfjgwdb0l7mj" />
              </span>
              <p className="mt-5 text-center text-[15px] leading-relaxed text-white/65" data-id="element-93" data-mp="2evx8gtnpn4yo">
                {t.footer.tagline}
              </p>
            </div>
            <div className="mt-6 flex gap-3" data-id="element-94" data-mp="3gbr0qn4amzel">
              {socials.map(({
              label,
              Icon
            }) => <a key={label} href="#contact" aria-label={label} className="flex h-10 w-10 items-center justify-center rounded-md bg-white/10 text-white transition-colors duration-150 ease-out hover:bg-rust" data-id="element-95" data-mp="3v8hqe4o60wr0">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-96" data-mp="335slg3f1hfy" />
                </a>)}
            </div>
          </div>

          <nav aria-label={t.footer.aria} data-id="element-97" data-mp="huwgsshgdt46">
            <h2 className="font-display text-sm font-bold uppercase tracking-wider text-white" data-id="element-98" data-mp="ctgwx3r0hsnd">
              {t.footer.quickLinksTitle}
            </h2>
            <ul className="mt-4 space-y-3" data-id="element-99" data-mp="qrfaw81f7n2c">
              {t.footer.links.map(link => <li key={link.href} data-id="element-100" data-mp="mtr86ithkpzw">
                  <a href={link.href} className="text-[15px] text-white/65 transition-colors duration-150 ease-out hover:text-rust-light" data-id="element-101" data-mp="tvcwfj28tpax">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-102" data-mp="18l2fitaakdzh">
            <h2 className="font-display text-sm font-bold uppercase tracking-wider text-white" data-id="element-103" data-mp="18kskuseaxing">
              {t.footer.callTitle}
            </h2>
            <a href={CONTACT.phoneHref} className="mt-4 flex items-center gap-2.5 whitespace-nowrap font-display text-2xl font-black text-rust-light transition-colors duration-150 ease-out hover:text-white" data-id="element-104" data-mp="1hkp4ugpqxtc6">
              <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-105" data-mp="1rhk08qqq3dm8" />
              {CONTACT.phone}
            </a>
            <p className="mt-3 text-[15px] text-white/65" data-id="element-106" data-mp="3oczpzct5yl73">{CONTACT.location}</p>
            <p className="text-[15px] text-white/65" data-id="element-107" data-mp="3tb18nwmogii1">{CONTACT.email}</p>
          </div>
        </div>

        <p className="mt-12 border-t border-white/10 pt-6 text-sm text-white/50" data-id="element-108" data-mp="2afx3f293sd71">
          {t.footer.copyright}
        </p>
      </div>
    </footer>;
}